import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakLoginService } from './keycloak-login.service';

/**
 * Trata o retorno do login pelo Keycloak na navegação inicial, antes do AuthGuard.
 * Assíncrono: o router aguarda o /api/auth/callback (sem corrida). O backend aplica o
 * role gate, então o front decide só pelo resultado.
 */
export const keycloakCallbackGuard: CanActivateFn = async (route) => {
    const router = inject(Router);

    if (route.queryParamMap.has('error')) {
        return router.createUrlTree(['/login'], { queryParams: { erro: 'certificado' } });
    }
    if (!route.queryParamMap.has('code') || !route.queryParamMap.has('state')) {
        return true;
    }

    const keycloakLogin = inject(KeycloakLoginService);
    const resultado = await keycloakLogin.completarSeRetorno();
    switch (resultado) {
        case 'ok':
            return router.parseUrl(keycloakLogin.consumirReturnUrl());
        case 'sem-acesso':
            return router.createUrlTree(['/login'], { queryParams: { erro: 'sem-acesso' } });
        default:
            return router.createUrlTree(['/login'], { queryParams: { erro: 'certificado' } });
    }
};
